var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout"},[_c('router-view'),_c('div',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }